export default "__VITE_ASSET__e3a3cb94__"